export default {
	"Testing":"测试",
	"Management":"管理",
	"Support":"援助",
	"Data Quality":"数据质量",
	"No new notifications":"没有新的通知",
	"Team Progress":"团队進步",
	"Add a task":"添加任務",
	"Click to search a task":"单机以搜索任務",
	"Open the list of all tasks":"打开所有任務列表",
	"View the latest notifications":"查看最新通知",
	"Change your personal settings":"更改您的個人设置",
	"Pick your side of the Force":"选择你的力量",
	"Dark":"黑暗",
	"Light":"光",
	"Pick a language":"选择一个语言",
	"Latest tasks in your projects":"項目中的最新任務",
	"Top margin in a popup window is smaller than the...":"弹出窗口中的上边距小於...",
	"Autocat report":"自動報告",
	"Navigations problem in the left menu":"左側菜单中的導航问題",
	"Assignment":"分配",
	"Gita Noda assigned you a new ticket":"Gita Noda给你一张新票",
	"Lorena Rush added new tasks":"Lorena Rush增加了新的任務",
	"'Confirm' button styling":"'確认'按钮样式",
	"Cubebeat report":"Cubebeat報告",
	"No ability to exit profile editing dialogue":"无法退出配置文件编辐对话框",
	"See all notifications":"查看所有通知",
	"Persons":"人们",
	"Click to sort":"点击排序",
	"Total tasks completed":"完成的任務总数",
	"Hours spent, %":"花费的时间，％",
	"Individual employee's progress":"个人员工的進步",
	"Total tasks by projects":"項目总任務",
	"incomplete":"残缺",
	"Tasks":"任務",
	"Meeting":"会议",
	"Mail":"邮件",
	"Calls":"呼叫",
	"Button text on mobile devices":"移动设备上的按钮文字",
	"Search pattern is ambiguous":"搜索模式含糊不清", 
	"Links in the upper right menu":"右上方菜单中的链接",
	"Menu thumbnails disappear when I click them":"单击它们時，菜单缩略图消失",
	"Document export is empty":"文档导出为空",
	"Button text in the right menu":"右侧菜单中的按钮文本",
	"Search is not working properly":"搜索无法正常工作",
	"How do I define which column the sort was activated from?":"如何定义从哪个列激活排序？",
	"How to apply fewer options of drop down menu for specific rows of datatable?":"如何无特定的楼據行行应用更少的下拉菜单选項？",
	"Prevent clearing CSS added to node after filterByAll() in datatable filter":"防止在datatable过濾器中的filterByAll（）之后清除添加到節点的CSS",
	"Can each series in a line chart have its own dataCollection?":"折线图中的每個系列都有自己的dataCollection吗？",
	"Labels in rangechart":"范围图中的标签",
	"onBlur event not working for MultiSelect":"onBlur事件不適用於MultiSelect",
	"Datatable focus on first cell":"Datatable專注於第一个细胞",
	"Binding Filters to each other":"将过濾器相互綁定",
	"Error: [DOM] Found 7 elements with non-unique id":"错误：[DOM]找到7個具有非唯一ID的元素",
	"Datatable editing within multiview":"多視图內的数据表编辑",
	"Dynamic load filtering doesnot work with custom request call to server":"动態加载筛選不適用於对服務器的自定義请求调用",
	"Task":"任務",
	"Project":"項目",
	"User":"用戶",
	"Start":"开始",
	"Completed":"已完成",
	"Add a new task":"添加新任務",
	"Assignee":"代理人",
	"Cancel":"取消",
	"Add":"加",
	"Click to complete/uncomplete the task":"单击以完成/取消完成任務",
	"Double-click to edit the task name":"双击以编辑任務名称",
	"Double-click to change the project":"双击一更改項目",
	"Double-click to assign to a different employee":"双击以分配给其他员工",
	"The task was created":"任務已創建",
	"The task was completed":"任務完成了",
	"Click on the red clock to complete the task":"单击红色时钟完成任務",
	"Week":"周",
	"tasks completed":"任務完成",
	"Go back to the dashboard":"返回儀表板", 
	"Ain't it amazing?":"这不是很棒吗？",
	"Meaning the view from your window. Even if it's too urban or too industrial to your taste, you can find curious beauty in its geometry.":"我的意思是窗外的景色。即使它过於都市化或过於工業化，你也可以在几何学中找到好奇的美",
	"Components":"组件",
	"Can you name all the Webix components that have been used to build the demo app?":"您能说出用於構建演示應用程序的所有Webix组件吗？",
	"We miss you":"我们想念你",
	"Been pretty busy lately, haven't you? That's great! But also do not forget about us.":"你最近一直很忙，不是吗？那很棒！但別忘了我们",
	"Have a nice day":"祝你今天愉快！",
	"Dear client, whenever you are reading this, we wish you a merry day. May luck and success attend you.":"亲爱的顾客,无论何時阅讀此讯息,我們都祝你圣诞快樂。祝你好運和成功",
	"Colors and Languages":"颜色和语言",
	"To pick a language or the color theme for the demo app, click on the avatar in the top right corner.":"要为演示应用选择语言或颜色主題,清单击右上角的頭像",
	"We love you":"我们爱你",
	"Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.":"亲爱的顾客，我们非常愛你。如果我们的感受是相互的，清联繫我们並下載Webix。然後我们會永遠愛你。",
};